<template>
  <v-app>
    <!-- <p class="top-alert">
      <b>Ross1000</b> è in fase di aggiornamento. La manutenzione inizia il
      giorno <b>15 Ottobre alle ore 18:00</b> e termina il giorno
      <b>17 Ottobre alle ore 10:00</b>.
    </p> -->

    <v-main>
      <router-view />
    </v-main>

    <v-alert
      ref="alert"
      :color="alertColor"
      dark
      border="left"
      prominent
      :dismissible="!loading"
      v-model="alertModel"
    >
      <v-row class="align-center">
        <v-col cols="2" v-if="loading">
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-col>
        <v-col :cols="loading ? 10 : 12">
          <div v-html="alertText"></div>
        </v-col>
      </v-row>
    </v-alert>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      alertText: "",
      alertModel: false,
      alertColor: "#e86a20",
      alertTimeout: null
    };
  },

  methods: {
    success(text) {
      this.showAlert(text, "#55b717");
    },
    error(text) {
      this.showAlert(text, "#e86a20");
    },
    progress(text) {
      this.showAlert(text, "#4c4c4c", true);
    },
    showAlert(text, color, loading = false) {
      clearTimeout(this.alertTimeout);

      this.loading = loading;
      this.alertColor = color;
      this.alertText = text;
      this.alertModel = true;

      this.alertTimeout = setTimeout(() => {
        this.alertModel = false;
      }, 5000);
    },
    hideAlert() {
      this.alertModel = false;
    }
  }
};
</script>

<style lang="scss">
.tourist-tax-pro-red {
  color: #e61e30;
}

.tourist-tax-pro-blue {
  color: #0f0f0f;
}

@media screen and (min-width: 1900px) {
  .container {
    max-width: 1040px;
  }
}

.v-input__slot {
  height: 52px !important;
  min-height: 52px !important;
}
</style>
<style lang="scss" scoped>
.v-alert {
  position: fixed;
  margin: 0;
  bottom: 30px;
  right: 30px;
}

.top-alert {
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 12px 8px;
  text-align: center;
  color: white;
  background-color: #e61e2f;
}
</style>
